import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import Spinner from "../components/common/Spinner/Spinner";
import { useUserGroups } from "../components/common/Auth/UserGroupsContext";

const ProtectedRoute = ({ source, children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [searchParams] = useSearchParams();
  const userAgent = navigator.userAgent || "";
  const { groupNamesFetched } = useUserGroups();

  const isNativeApp = localStorage.getItem("webView") === "true" || userAgent.includes("EDPFlutterApp");

  useEffect(() => {
    validateAccess();
  }, []);

  const validateAccess = async () => {
    try {
      let token =
        searchParams.get("token") ||
        sessionStorage.getItem("token") ||
        localStorage.getItem("token");

      if (!token) {
        setAuthorized(false);
        setLoading(false);
        return;
      }

      if (isNativeApp) {
        localStorage.setItem("token", token);
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Auth/validate-access?source=${source}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            //source: source,
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok) {
        setAuthorized(false);
        return;
      }

      const data = await response.json();
      if (!data.authorized) {
        setAuthorized(false);
        return;
      }
      setAuthorized(data.authorized === true);
    } catch (error) {
      console.error(error);
      setAuthorized(false);

    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spinner />;
  }

  if (!authorized) {
    return <Navigate to="/401" replace />;
  }


  // WAIT UNTIL GROUPS LOAD
  if (!groupNamesFetched) {
    return (<Spinner />);
  }

  return children;
};

export default ProtectedRoute;



// import React, { useMemo, useEffect, useState } from "react";
// import { Navigate, useNavigate } from "react-router-dom";
// import { getLocalStorageItem } from "../utils/HelperFunctions";
// import { useSearchParams } from "react-router-dom";
// import { useEDPContext } from "../components/EDPContext";
// import { decryptUserId } from "./cryptoUtils";


// const ProtectedRoute = ({ source, children }) => {
//   const username = getLocalStorageItem("username");
//   const userAgent = navigator.userAgent || "";
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const isNativeApp = localStorage.getItem("webView") === "true" || userAgent.includes("EDPFlutterApp");
//   const [isUserNameAvailable, setisUserNameAvailable] = useState(undefined);


//   const groupNames = JSON.parse(getLocalStorageItem("groups"));

//   //Added for Native app - EADAdmin issue where we globally storing 2 values.
//   // isSourceAdmin - For setting current source boolean state and token, when source == "eadadmin"
//   if (isNativeApp) {
//     const URLJWTtoken = searchParams.get("token");
//     if (source == "eadadmin") {
//       window.isSourceAdmin = true;
//       window.NativeToken = URLJWTtoken;
//       localStorage.setItem("token", URLJWTtoken)
//     }
//     else {
//       window.isSourceAdmin = false;
//     }
//   }

//   // Fix for Native App - Admin application redirection issue:
//   // Added logic to fetch user details and store them in localStorage
//   // because the Header component was not triggered initially,
//   // causing missing user data (like username) when source was 'eadadmin'.
//   useEffect(async () => {

//     const getUserDetails = async () => {
//       const token = searchParams.get("token") || localStorage.getItem("token"); // Retrieve token from storage
//       if (!token) {
//         return;
//       }

//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth/get-user`, {
//           method: "GET",
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch user details");
//         }

//         const data = await response.json();
//         const decryptUserName = decryptUserId(data.username);
//         const decryptEmail = decryptUserId(data.email);
//         data.username = decryptUserName;
//         data.email = decryptEmail;

//         localStorage.setItem("UEmail", data.email);
//         // localStorage.setItem("TokenExpTime", data.tokenExpirationTime);
//         localStorage.setItem("username", data.username);
//         localStorage.setItem("UserId", data.id);
//         const groupNames = data.groups.map(item => item.groupName);
//         const storedGroups = JSON.stringify(groupNames)
//         localStorage.setItem("groups", JSON.stringify(groupNames));
//         return data; // Contains userId and userName
//       } catch (error) {
//         setisUserNameAvailable(false)
//         console.log(error);
//       }
//     }
//     if (isNativeApp && source === "eadadmin") {
//       const localUsername = localStorage.getItem("username");

//       if (!localUsername || localUsername?.trim() === "") {
//         const data = await getUserDetails();
//         if (data?.username && data.username.trim() != "") {
//           window.isSourceAdmin = false;
//           window.NativeToken = "";
//           setisUserNameAvailable(true);
//         }
//         else {
//           setisUserNameAvailable(false);
//         }
//       }
//       else {
//         setisUserNameAvailable(true);
//       }
//     }
//   }, []);


//   if (isNativeApp && source === "eadadmin") {
//     if (isUserNameAvailable == undefined) {
//       return null;
//     }
//   }

//   if (isNativeApp && source == "eadadmin") {
//     if (isUserNameAvailable == false) {
//       return <Navigate to="/" replace />;
//     }
//   }
//   else {
//     // Check if the user is authorized
//     if (!username || username.trim() === "") {
//       // If no username is found, redirect to login
//       return <Navigate to="/" replace />;
//     }
//   }


//   if (isUserAuthorized(groupNames, source)) {
//     // User is authorized, render the protected content
//     return children;
//   }

//   // Redirect unauthorized users to the "401 Unauthorized" page
//   return <Navigate to="/401" replace />;
// };

// const isUserAuthorized = (userGroups, source) => {
//   if (source === "eadadmin") {
//     const allowedGroups = ["Administrator", "MWQ Internal", "AQ Internal"];

//     return userGroups.some((group) => allowedGroups.includes(group));
//   }
//   if (source === "sdm") {
//     const allowedGroups = ["Sample Management Tool", "SDM Admin"];
//     return userGroups.some((group) => allowedGroups.includes(group));
//   }
//   if (source === "permit") {
//     const allowedGroups = ["Permit Dashboard"];
//     return userGroups.some((group) => allowedGroups.includes(group));
//   }
//   return false; // Default to unauthorized if the source isn't recognized
// };

// export default ProtectedRoute;
